class StorageClass {
  constructor() {
    this.isAvailable = StorageClass.isAvailable();
    if (this.isAvailable) {
      this.storage = window.localStorage;
    } else {
      this.storage = null;
    }
  }

  static isAvailable() {
    try {
      return window.localStorage &&
        window.localStorage.setItem &&
        window.localStorage.removeItem &&
        window.localStorage.getItem;
    } catch (error) {
      return false;
    }
  }

  get(key) {
    if (this.isAvailable) {
      return JSON.parse(this.storage.getItem(key));
    }
    return undefined;
  }

  set(key, item) {
    if (item === undefined) {
      return;
    }
    if (this.isAvailable) {
      this.storage.setItem(key, JSON.stringify(item));
    }
  }

  remove(key) {
    if (this.isAvailable) {
      this.storage.removeItem(key);
    }
  }

  secureSet(key, item) {
    // TODO: implement this securely.
    this.set(key, item);
  }

  secureGet(key) {
    // TODO: implement this securely.
    return this.get(key);
  }
}

const Storage = new StorageClass();

export { Storage };




// WEBPACK FOOTER //
// ./src/helpers/Storage.js